import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
//import { GETMETHODREAD } from '../axiosComponent/read';
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";

const MyOrderType = ({
  field: { name },
  form: { setFieldValue },
  ...props
}) => {
  const [content, setcontent] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    // $("#searchType .dropdown").removeClass("dropdown")
    setloading(true);

    allAxiosCommonRequest({
      url: "transporter-allocation/orders/masters/service/type",
      method: "get",
    }) //CommonGetApi({ url: 'branch' })
      .then((data) => {
        let cont = data.data.data;
        setcontent(cont);
        setloading(false);
      })
      .catch((error) => console.log(error));

    /* GETMETHODREAD({
            newUrl: 'transporter-allocation/orders/masters/service/type',
            response: ((data) => {
                let cont = data.data.data
                setcontent(cont)
                setloading(false)
            })
        }) */
  }, []);
  let options = [];
  if (content.length > 0) {
    content.map((object, index) => {
      let temp = {};
      temp.key = object.service_type_id;
      temp.text = `${object.service_type_name}`;
      temp.value = object.service_type_name.toLowerCase();
      return (options[index] = temp);
    });
  }
  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
  };
  return (
    <Dropdown
      selection
      loading={loading ? true : false}
      style={{ width: "100%" }}
      onChange={handleChange}
      options={options}
      // id="searchType"
      noResultsMessage="Search for Result"
      {...props}
    />
  );
};

export default MyOrderType;
